module.exports = __webpack_public_path__ + "static/media/SMART-API_new_logo.b85b9cb9.png";